<template>
  <div>
    <div class="conten">
      <div
        style="padding: 20px 50px;box-sizing: border-box;line-height: 20px;font-size:14px;"
      >
        <div>规则设置</div>
        <el-divider></el-divider>
        <el-form ref="form" label-width="180px">
          <el-form-item label="抽奖机会">
            <el-checkbox
              name="type"
              style="display: block;"
              v-model="form.is_free"
              >免费次数</el-checkbox
            >
            <div class="content_s" v-if="form.is_free">
              <div>
                每人
                <span>
                  免费抽奖
                  <el-input-number
                    size="small"
                    v-model="form.free_num"
                  ></el-input-number>
                  次
                </span>
              </div>
            </div>
            <el-checkbox
              name="type"
              style="display: block;"
              v-model="form.is_consume"
              >加油获取(非加油卡)</el-checkbox
            >
            <Select v-if="form.is_consume" Type="is_consume" :Status="status" />
            <el-checkbox
              name="type"
              style="display: block;"
              v-model="form.is_consume_card_recharge"
              >加油卡充值</el-checkbox
            >
            <Select
              v-if="form.is_consume_card_recharge"
              Type="is_consume_card_recharge"
              :Status="status"
            />

            <el-checkbox
              name="type"
              style="display: block;"
              v-model="form.is_consume_card_consume"
              >加油卡消费</el-checkbox
            >
            <Select
              v-if="form.is_consume_card_consume"
              Type="is_consume_card_consume"
              :Status="status"
            />

            <el-checkbox
              name="type"
              style="display: block;"
              v-model="form.is_integral"
              >积分换取</el-checkbox
            >
            <div class="content_s" v-if="form.is_integral">
              <el-input-number
                size="small"
                v-model="form.integral_num"
              ></el-input-number>
              积分换取1次
            </div>
            <el-checkbox name="type" style="display: block;" v-model="form.is_display"
							>是否显示抽奖按钮</el-checkbox
						>
          </el-form-item>
          <el-form-item label="分享设置">
            <el-radio v-model="form.is_share" :label="0">关 闭</el-radio>
            <el-radio v-model="form.is_share" :label="1">开 启</el-radio>
            <div class="content_s" v-if="form.is_share == 1">
              <div>
                分享标题:
                <el-input
                  placeholder="输入分享标语"
                  size="small"
                  v-model="form.share_title"
                  style="width: 40%;"
                >
                </el-input>
              </div>
              分享朋友圈获得
              <el-input
                type="number"
                class="no-number"
                placeholder="整数"
                size="small"
                v-model="form.share_add_num"
                style="width: 10%;"
              >
              </el-input>
              抽奖次数,最大可分享次数
              <el-input
                type="number"
                class="no-number"
                placeholder="整数"
                size="small"
                v-model="form.max_share_num"
                style="width: 10%;"
              >
              </el-input>
              次
              <div style="margin-top: 10px;display: flex">
                <div>
                  <img style="width: 110px;height: 60px" v-if="this.form.share_pic_url==''" src="@/assets/images/upload.png">
                  <img style="width: 110px;height: 60px" v-else :src="this.form.share_pic_url">
                  <el-upload
                    class="upload-demo"
                    action="#"
                    multiple
                    :http-request="(file)=>{
                    return upload(file,0)
                  }"
                    :show-file-list="false">
                    <el-button size="small" type="primary">添加分享图片</el-button>
                  </el-upload>
                </div>
                <div>
                  <el-input
                    style="margin-left: 20px;width: 400px"
                    type="textarea"
                    placeholder="请输入分享详细内容"
                    v-model="form.share_statement"
                    maxlength="130"
                    show-word-limit
                    :rows="5"
                  >
                  </el-input>
                </div>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="组队参与">
            <el-radio v-model="form.is_team" :label="0">关 闭</el-radio>
            <el-radio v-model="form.is_team" :label="1">开 启</el-radio>
            <div class="content_s" v-if="form.is_team == 1">
<!--              抽奖组队-->
              <div>
                组队标题:
                <el-input
                  placeholder="输入组队标语"
                  size="small"
                  v-model="form.team_title"
                  style="width: 40%;"
                >
                </el-input>
              </div>
              <el-select
                v-model="form.team_time_type"
                size="small"
                style="margin-right: 10px;width: 15%;"
                placeholder="请选择"
              >
                <el-option label="当天" :value="1"></el-option>
                <el-option label="抽奖活动期间" :value="2"> </el-option>
              </el-select>
              <span>组成 </span>
              <el-select
                v-model="form.team_people_num"
                size="small"
                style="margin-right: 10px;width: 10%;"
                placeholder="请选择"
              >
                <el-option label="3" :value="3"> </el-option>
                <el-option label="6" :value="6"> </el-option>
                <el-option label="8" :value="8"> </el-option>
              </el-select>
              <span>人小队, 队内成员可额外增加 </span>
              <el-input
                type="number"
                class="no-number"
                placeholder="整数"
                size="small"
                v-model="form.team_add_num"
                style="width: 10%;"
              >
              </el-input>
              抽奖机会, 每人最大组队
              <el-input
                type="number"
                class="no-number"
                placeholder="整数"
                size="small"
                v-model="form.team_max_num"
                style="width: 10%;"
              >
              </el-input>
              次
<!--              组队分享-->
              <div style="margin-top: 10px;display: flex">
                <div>
                  <img style="width: 110px;height: 60px" v-if="this.form.team_pic_url==''" src="@/assets/images/upload.png">
                  <img style="width: 110px;height: 60px" v-else :src="this.form.team_pic_url">
                  <el-upload
                    class="upload-demo"
                    action="#"
                    multiple
                    :http-request="(file)=>{
                    return upload(file,1)
                  }"
                    :show-file-list="false">
                    <el-button size="small" type="primary">添加分享图片</el-button>
                  </el-upload>
                </div>
                <div>
                  <el-input
                    style="margin-left: 20px;width: 400px"
                    type="textarea"
                    placeholder="请输入组队详细内容"
                    v-model="form.team_statement"
                    maxlength="130"
                    show-word-limit
                    :rows="5"
                  >
                  </el-input>
                </div>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="规则说明">
            <el-radio v-model="form.intro_type" :label="1" @change="Click"
              >模板</el-radio
            >
            <el-radio v-model="form.intro_type" :label="2" @change="Click"
              >自定义</el-radio
            >
            <div
              id="box"
              v-if="form.intro_type == 1"
              disabled
              style="width: 20vw;display: block;background-color:#f8f8f8;height: auto;border-radius: 5px;padding: 0 5px;font-size:12px;color: #cccccc;"
            >
              <div v-if="form.is_free" class="free">
                免费抽奖: {{ form.free_num }}次
              </div>
              <div v-if="form.is_consume">
                <span class="consume">加油获取(非加油卡): </span>
                <span
                  isspan="span"
                  v-for="(item, i) in form.consume_products"
                  :key="i"
                >
                  每消费{{ item.quota }}
                  <span
                    class="consumess"
                    v-if="item.quota_type == 1 || item.quota_type == 2"
                    >元</span
                  >
                  <span class="consumess" v-else>升</span>
                  获得抽奖{{ item.num }}次;
                </span>
              </div>
              <div v-if="form.is_consume_card_recharge">
                <span class="consume_card_recharge">加油卡充值: </span>
                <span
                  v-for="(item, i) in form.consume_card_recharge_cards"
                  :key="i"
                >
                  <span class="consume_card_recharges"
                    >每充值{{ item.quota }}</span
                  >
                  <span
                    class="consume_card_rechargess"
                    v-if="item.quota_type == 1 || item.quota_type == 2"
                    >元</span
                  >
                  <span class="consume_card_rechargess" v-else>升</span>
                  <span class="consume_card_rechargess_s"
                    >获得抽奖{{ item.num }}次;
                  </span>
                </span>
              </div>
              <div v-if="form.is_consume_card_consume">
                <span class="is_consume_card_consume">加油卡消费: </span>
                <span
                  v-for="(item, i) in form.consume_card_consume_cards"
                  :key="i"
                >
                  <span class="is_consume_card_consumes"
                    >每消费{{ item.quota }}</span
                  >
                  <span
                    class="is_consume_card_consumess"
                    v-if="item.quota_type == 1 || item.quota_type == 2"
                    >元</span
                  >
                  <span class="is_consume_card_consumess" v-else>升</span>
                  <span class="is_consume_card_consumess_s"
                    >获得抽奖{{ item.num }}次;
                  </span>
                </span>
              </div>
              <div v-if="form.is_integral">
                <span isspan="span">积分换取: </span>
                <span isspan="span">每{{ form.integral_num }}积分换取一次</span>
              </div>
              <div v-if="form.is_share == 1">
                <span isspan="span">朋友圈分享: </span>
                <span isspan="span"
                  >每分享一次获得{{ form.share_add_num }}次抽奖机会,</span
                >
                <span isspan="span">最大可分享{{ form.max_share_num }}次</span>
              </div>
              <div v-if="form.is_team == 1">
                <span isspan="span">组队: </span>
                <span isspan="span" v-if="form.team_time_type == 1">当天</span>
                <span isspan="span" v-else>抽奖活动期间</span>
                <span isspan="span"
                  >成功组队{{ form.team_people_num }}人,每人可获得{{
                    form.team_add_num
                  }}次抽奖机会,每人最多组队{{ form.team_max_num }}次</span
                >
              </div>
            </div>
            <el-input
              v-else
              type="textarea"
              v-model="form.intro"
              placeholder="请填写规则"
              rows="8"
              show-word-limit
              style="width: 20vw;display: block;"
            >
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="Previous">上一步</el-button>
            <el-button type="primary" @click="next">下一步</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import select from "@/views/apply/newVip/marketing/lottery/Components/select";
import store from "@/store/index";
import { addImage } from "@/api/mall";

export default {
  components: {
    Select: select,
  },
  data() {
    return {
      form: {},
      status: 0,
      str1: "",
      str2: "",
      str3: "",
      str4: "",
      str5: "",
    };
  },
  mounted() {
    this.form = store.getters.lotteryfrom;
    console.log('23333',store.getters.lotteryfrom)
  },
  watch: {},
  methods: {
    //图片上传
    upload(file,key){
      const loading = this.$loading({
        lock: true,
        text: '上传中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      var formdata = new FormData();
      formdata.append('image', file.file);
      addImage(formdata).then(res => {
        if(res.code == 200){
          this.$message.success(res.msg)
          if(key == 1){
            this.form.team_pic_url = res.data.url
          }else {
            this.form.share_pic_url = res.data.url
          }
          this.$forceUpdate()
          loading.close()
        }else {
          this.$message(res.msg)
        }

      })
    },
    Click(val) {
      console.log("2222", val);
      if (val == 2) {
        this.filter();
      }
    },
    Previous() {
      this.$emit("active", 0);
    },
    filter() {
      var free,
        consume,
        consume_card_recharge,
        consume_card_consume,
        integral,
        share,
        team;
      var index1, index2, index3, index4, index5, index6, index7;
      let arry = [];
      if (this.form.is_free) {
        free = "免费抽奖: " + this.form.free_num + "次";
        arry.push(free);
        console.log(free);
      } else {
        index1 = arry.indexOf(free);
        if (index1 != -1) {
          arry.splice(index1, 1);
        }
      }

      if (this.form.is_consume) {
        let arr1 = [];
        this.form.consume_products.forEach((item, i) => {
          if (item.quota_type == 3) {
            arr1.push("每消费" + item.quota + "升获得抽奖" + item.num + "次");
          } else {
            arr1.push("每消费" + item.quota + "元获得抽奖" + item.num + "次");
          }
        });
        consume = "加油获取(非加油卡): " + arr1.join(";");
        arry.push(consume);
      } else {
        index2 = arry.indexOf(consume);
        if (index2 != -1) {
          arry.splice(index2, 1);
        }
      }

      if (this.form.is_consume_card_recharge) {
        let arr2 = [];
        this.form.consume_card_recharge_cards.forEach((item, i) => {
          if (item.quota_type == 3) {
            arr2.push("每消费" + item.quota + "升获得抽奖" + item.num + "次");
          } else {
            arr2.push("每消费" + item.quota + "元获得抽奖" + item.num + "次");
          }
        });
        consume_card_recharge = "加油卡充值: " + arr2.join(";");
        arry.push(consume_card_recharge);
      } else {
        index3 = arry.indexOf(consume_card_recharge);
        if (index3 != -1) {
          arry.splice(index3, 1);
        }
      }

      if (this.form.is_consume_card_consume) {
        let arr3 = [];
        this.form.consume_card_consume_cards.forEach((item, i) => {
          if (item.quota_type == 3) {
            arr3.push("每消费" + item.quota + "升获得抽奖" + item.num + "次");
          } else {
            arr3.push("每消费" + item.quota + "元获得抽奖" + item.num + "次");
          }
        });
        consume_card_consume = "加油卡消费: " + arr3.join(";");
        arry.push(consume_card_consume);
      } else {
        index4 = arry.indexOf(consume_card_consume);
        if (index4 != -1) {
          arry.splice(index4, 1);
        }
      }

      if (this.form.is_integral) {
        integral =
          "积分: 每" + Number(this.form.integral_num) + "积分换取一次抽奖机会";
        arry.push(integral);
      } else {
        index5 = arry.indexOf(integral);
        if (index5 != -1) {
          arry.splice(index5, 1);
        }
      }

      if (this.form.is_share == 1) {
        share =
          "朋友圈分享: 每分享一次获得" +
          this.form.share_add_num +
          "次抽奖机会,最大可分享" +
          this.form.max_share_num +
          "次";
        arry.push(share);
      } else {
        index6 = arry.indexOf(share);
        if (index6 != -1) {
          arry.splice(index6, 1);
        }
      }

      if (this.form.is_team == 1) {
        if (this.form.team_time_type == 1) {
          team =
            "组队: " +
            "当天" +
            "成功组队" +
            this.form.team_people_num +
            "人,每人可获得" +
            this.form.team_add_num +
            "次抽奖机会,每人最大组队" +
            this.form.team_max_num +
            "次";
        } else {
          team =
            "组队: " +
            "活动期间" +
            "成功组队" +
            this.form.team_people_num +
            "人,每人可获得" +
            this.form.team_add_num +
            "次抽奖机会,每人最大组队" +
            this.form.team_max_num +
            "次";
        }
        arry.push(team);
      } else {
        index7 = arry.indexOf(team);
        if (index7 != -1) {
          arry.splice(index7, 1);
        }
      }
      this.form.intro = arry.join("\n");
      console.log(this.form.intro);
    },
    next() {
      console.log("665", this.form);
      if (
        !this.form.is_free &&
        !this.form.is_consume &&
        !this.form.is_consume_card_recharge &&
        !this.form.is_consume_card_consume &&
        !this.form.is_integral
      ) {
        this.$message.error("请至少选择一种抽奖机会规则");
        return false;
      }
      if (this.form.intro_type == 1) {
        this.filter();
      }
      if (this.form.intro == "") this.form.intro = "无";

      this.status = 1;
      this.$emit("active", 2);
    },
  },
};
</script>
<style lang="scss" scoped>
.conten {
  width: 95%;
  // height: 40vw;
  background-color: #ffffff;
  margin: 20px auto;
  padding: 20px 0;

  // line-height: 5vw;
}
.content_s {
  width: 60%;
  background-color: #f8f8f8;
  padding: 1vw;
  margin-left: 10px;
}
</style>
